import { createContext, useContext, useState } from 'react';

const COOKIE_KEY = 'cookies_accepted';

const ConsentContext = createContext(undefined);

function getCookieValue(name) {
  const match = document.cookie.match(
    new RegExp('(?:^|;\\s*)' + name + '=([^;]+)'),
  );
  return match ? match[1] : null;
}

function setCookieValue(name, value, days) {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`;
}

function updateGtagConsent(granted) {
  const status = granted ? 'granted' : 'denied';
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('consent', 'update', {
      ad_personalization: status,
      ad_storage: status,
      ad_user_data: status,
      analytics_storage: status,
    });
  }
}

// Doc: https://developers.google.com/tag-platform/security/concepts/consent-mode
export function ConsentProvider({ children }) {
  const [cookiesAccepted, setCookiesAcceptedState] = useState(() => {
    const existing = getCookieValue(COOKIE_KEY);
    if (existing === 'true') return true;
    if (existing === 'false') return false;
    return undefined;
  });

  const setCookiesAccepted = (value) => {
    setCookieValue(COOKIE_KEY, String(value), 365);
    setCookiesAcceptedState(value);
    updateGtagConsent(value);
  };

  return (
    <ConsentContext.Provider value={{ cookiesAccepted, setCookiesAccepted }}>
      {children}
    </ConsentContext.Provider>
  );
}

export function useConsent() {
  const context = useContext(ConsentContext);
  if (context === undefined) {
    throw new Error('useConsent must be used within ConsentProvider');
  }
  return context;
}
